import { useQuery } from "@tanstack/react-query";
import { meApi } from "@/api/me";
import { SettingsLayout } from "@/components/settings/SettingsLayout";
import { SettingsCard } from "@/components/settings/SettingsCard";
import { PasswordChangeForm } from "./PasswordChangeForm";
import { DeleteAccountSection } from "./DeleteAccountSection";

export function AccountPage() {
  const { data: me } = useQuery({ queryKey: ["me"], queryFn: meApi.get });

  return (
    <SettingsLayout title="Account" description="Manage your sign-in details.">
      <SettingsCard title="Email" description="Your account email is used for sign-in.">
        <div className="flex justify-between items-center text-sm">
          <span className="text-muted-foreground">Email</span>
          <span className="font-mono">{me?.email ?? "—"}</span>
        </div>
        <p className="text-xs text-muted-foreground italic">Coming soon: change email.</p>
      </SettingsCard>

      <SettingsCard title="Password" description="Change your account password.">
        <PasswordChangeForm />
      </SettingsCard>

      <SettingsCard
        title="Danger zone"
        description="Permanent and irreversible actions."
        className="border-destructive/40"
      >
        <DeleteAccountSection />
      </SettingsCard>

      <SettingsCard title="Legal" description="Tapelens policies and how to reach us.">
        <div className="flex flex-wrap gap-3 text-sm">
          <a href="https://tapelens.com/legal/terms" className="underline-offset-4 hover:underline">
            Terms of Service
          </a>
          <span className="text-muted-foreground">·</span>
          <a href="https://tapelens.com/legal/privacy" className="underline-offset-4 hover:underline">
            Privacy Policy
          </a>
          <span className="text-muted-foreground">·</span>
          <a href="https://tapelens.com/legal/refund" className="underline-offset-4 hover:underline">
            Refund Policy
          </a>
          <span className="text-muted-foreground">·</span>
          <a href="https://tapelens.com/contact-us" className="underline-offset-4 hover:underline">
            Contact us
          </a>
        </div>
      </SettingsCard>
    </SettingsLayout>
  );
}
